export default {

  SET_ACCOUNT_VERIFIED(state) {
    state.accountVerified = true;
    state.accountVerifiedMsg = 'Account Verified';
  },
};
